/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { AuthenticationService, Logger } from '@app/core';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { DataStateChangeEvent, GridDataResult } from '@progress/kendo-angular-grid';
import { ApiQuery } from '@app/core/http/api-query';
import { VenuesService } from '@app/settings/venues/venues.service';
import { VenuesFormService } from '@app/settings/venues/venues-form.service';
import { Venue } from '@app/settings/venues/venue.model';
import { KendoGridComponent } from '@app/shared/kendo/kendo-grid.component';
import { KendoGridService } from '@app/shared/kendo/kendo-grid.service';
import { VenuesSeoFormService } from '@app/settings/venues/venues-seo-form.service';
import { environment } from '@env/environment';
import { LaravelModelsEnum } from '@app/shared/models/model.model';
import { MediaLibraryAcceptTypes } from '@app/shared/components/media-library/media-library-accept-types.enum';
import { CustomKendoFilter } from '@app/shared/kendo/custom-kendo-filter';
import { AccessService } from '@app/core/access/access.service';
import { UserRoleType } from '@app/settings/users/user-role-type.enum';

const log = new Logger('VenuesListComponent');

@Component({
  selector: 'app-venues-list',
  templateUrl: './venues-list.component.html',
  styleUrls: ['./venues-list.component.scss'],
})
export class VenuesListComponent extends KendoGridComponent implements OnInit {
  venuesResponse: PaginatedResponse;
  data: GridDataResult;
  state: DataStateChangeEvent;
  apiQuery: ApiQuery = new ApiQuery();
  env = environment;
  AuthenticationService = AuthenticationService;
  LaravelModels = LaravelModelsEnum;
  MediaLibraryAcceptTypes = MediaLibraryAcceptTypes;

  UserRoleType = UserRoleType;

  constructor(
    private venuesService: VenuesService,
    private venuesFormService: VenuesFormService,
    protected kendoGridService: KendoGridService,
    private venuesSeoFormService: VenuesSeoFormService,
    public accessService: AccessService
  ) {
    super(kendoGridService);
  }

  ngOnInit() {
    this.state = CustomKendoFilter.getStateFromStorage('VenuesListComponent');
    this.loadData(this.state);
  }

  /**
   *
   * @param state зарежда данни от сървиса
   */
  loadData(state: DataStateChangeEvent = null) {
    this.state = state;
    this.apiQuery.setDataSetFilters(state).addInclude('city.country');

    this.venuesService.index(this.apiQuery).subscribe((response: PaginatedResponse) => {
      this.venuesResponse = response;
      this.data = response.getGridData();
    });

    CustomKendoFilter.pushStateInStorage('VenuesListComponent', this.state);
  }

  /**
   * Отваря празен модал за добавяне на Venue
   */
  add() {
    this.venuesFormService.open().then(
      (response) => {
        if (response) {
          // Reload data after adding a new venue
          this.loadData(this.state);
        }
      },
      (err) => {
        log.info('modal closed without adding');
      }
    );
  }

  /**
   * @param venue отваря модал с вече попълнено Venue готово за едит
   */

  /**
   * @param venue отваря модал с вече попълнено Venue готово за едит
   */
  edit(venue: Venue) {
    this.venuesFormService.open(venue).then(
      (response) => {
        if (response) {
          // Reload data after editing the venue
          this.loadData(this.state);
        }
      },
      (err) => {
        log.info('modal closed without saving changes');
      }
    );
  }

  /**
   *
   * @param venue Изтрива Venue
   */
  delete(venue: Venue) {
    this.venuesService.destroy(venue.id).subscribe(() => {
      this.loadData(this.state);
    });
  }

  editSeo(venue: Venue): void {
    this.venuesSeoFormService.open(venue);
  }

  clearFilters() {
    this.apiQuery = new ApiQuery();
    this.loadData();
  }
}
